phpjs = require('./build/npm');

phpjs.registerGlobals = function() {
  for (var key in this) {
    global[key] = this[key];
  }
};

module.exports = phpjs;



/*****************
 ** WEBPACK FOOTER
 ** ./~/phpjs/index.js
 ** module id = 802
 ** module chunks = 0
 **/